import React from "react";
import RCPagination from "rc-pagination";
import { useTranslation } from "react-i18next";
import { ReactComponent as DoubleArrow } from "img/icons/navigation/doubleChevron.svg";
import "./pagination.scss";

const Pagination = (props) => {
  const { t } = useTranslation();
  return (
    <RCPagination
      {...props}
      className='customPagination'
      prevIcon={<DoubleArrow />}
      nextIcon={<DoubleArrow />}
      showTotal={(total, [from, to]) => t("sharedUi.pagination.range", { from, to, total })}
      showTitle={false}
    />
  );
};

export default Pagination;
